import React, { FunctionComponent } from 'react'
import formatTime from '../util/formatTime'

type ClockProps = {
	time: number
}

const Clock: FunctionComponent<ClockProps> = ({ time }) => (
	<div className="clock">{formatTime(time)}</div>
)

export default Clock
